module.exports = __webpack_public_path__ + "static/img/video.09ec4416.png";